// src/components/auth/Login.js
import React, { useState } from "react";
import { forgotPassword } from "../../api/auth";
import { useNavigate } from 'react-router-dom';
import { useUser } from "../../api/AuthContext";
import Footer from "../Shared/Footer";
import Modal from "../Shared/Modal";
import Swal from "sweetalert2";


const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(""); 
    setIsProcessing(true);
    try {
      const response = await forgotPassword(email);
      setIsProcessing(false); 
      Swal.fire({
        icon: "success",
        title: "Password Reset Email Sent!",
        text: "Check your email for reset instructions.",
        confirmButtonColor: "#75c043"
    }).then((result) => {
        if (result.isConfirmed) {
            navigate("/login"); // Redirect to login page
        }
    });
    //   navigate('/user/');
    } catch (err) {
        setIsProcessing(false);
        let errorMessage = err.response?.data?.detail || "Something went wrong. Please try again.";

    // Check if the error contains "No data found for email"
    if (errorMessage.includes("No data found for email")) {
      errorMessage = "Email not registered with us";
    }
    setError(errorMessage);

    }
  };

  return (
    <div>
        {/* <SignupSuccessModal /> */}
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
            <div className="row">
                <div className="col-12">
                    <div className="breadcrumb-contain">
                        <h2 className="mb-2">Forgot Password?</h2>
                        <nav>
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/">
                                        <i className="fa-solid fa-house"></i>
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Forgot Password?</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- Breadcrumb Section End --> */}

    {/* <!-- log in section start --> */}
    <section className="log-in-section background-image-2 section-b-space">
        <div className="container-fluid-lg w-100">
            <div className="row">
                <div className="col-xxl-6 col-xl-5 col-lg-6 d-lg-block d-none ms-auto">
                    <div className="image-contain">
                        <img src="../assets/images/inner-page/login.png" className="img-fluid" alt="" />
                    </div>
                </div>

                <div className="col-xxl-4 col-xl-5 col-lg-6 col-sm-8 mx-auto">
                    <div className="log-in-box">
                        <div className="log-in-title">
                            <h3>Welcome To Reducarb</h3>
                            <h4>Enter your email to reset passowrd..</h4>
                        </div>

                        <div className="input-box">
                            <form className="row g-4" onSubmit={handleSubmit}>
                                <div className="col-12">
                                    <div className="form-floating theme-form-floating log-in-form">
                                        <input type="email" placeholder="Enter valid email" className="form-control" required value={email} onChange={(e) => setEmail(e.target.value)} />
                                        {/* <label htmlFor="username">Username</label> */}
                                    </div>
                                </div>

                                {/* <div className="col-12">
                                    <button className="btn btn-md cart-button text-white w-100 justify-content-center"
                                    
                        style={{
                          backgroundColor: "#3150A3",
                          fontWeight: "bold",
                        }}type="submit">Submit</button>
                                    {error && <p style={{ color: "red", fontSize:"14px !important", marginTop: "10px", textAlign: "center" }}>{error}</p>}
                                </div> */}

<div className="col-12">
    <button
        className="btn btn-md cart-button text-white w-100 justify-content-center"
        style={{
            backgroundColor: "#3150A3",
            fontWeight: "bold",
        }}
        type="submit"
        disabled={isProcessing} // Disable button while processing
    >
        {isProcessing ? (
            <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Processing...
            </>
        ) : (
            "Submit"
        )}
    </button>
    {error && (
        <p style={{ color: "red", fontSize: "14px", marginTop: "10px", textAlign: "center" }}>
            {error}
        </p>
    )}
</div>

                            </form>
                        </div>

                        <div className="sign-up-box">
                            <h4>Already have an account?</h4>
                            <a href="/login">Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* <!-- log in section end --> */}

    {/* {signupSuccess && (
        <Modal
          title="Signup Successful!"
          modalType="success"
          bodyText="Welcome! Your signup was successful. Please log in to continue."
          modalId="loginModal"
        />
      )} */}

    <Footer/>
    </div>
  );
};

export default ForgotPassword;
